import { render, staticRenderFns } from "./DetailAppleScreenshotsForm.vue?vue&type=template&id=fddaab5c&scoped=true&"
import script from "./DetailAppleScreenshotsForm.vue?vue&type=script&lang=ts&"
export * from "./DetailAppleScreenshotsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fddaab5c",
  null
  
)

export default component.exports